export enum EEstadoCampana {
  ACTIVA = 'ACTIVA',
  PAUSADA = 'PAUSADA',
  FINALIZADA = 'FINALIZADA',
}

export enum EObjetivoCampana {
  PRODUCTO = 'PRODUCTO',
  CATEGORIA = 'CATEGORIA',
}

export enum ETipoDescuentoCampana {
  PORCENTAJE = 'PORCENTAJE',
  MONTO = 'MONTO',
}

export interface ICampanaDetalleData {
  id?: number;
  objetivo_tipo: EObjetivoCampana;
  producto_id: number | null;
  categoria_id: number | null;
  tipo_descuento: ETipoDescuentoCampana;
  valor_descuento: number;
  precio_minimo: number;
  prioridad: number;
}

export interface ICampanaData {
  id: number;
  nombre: string;
  descripcion: string;
  estado: EEstadoCampana;
  fecha_inicio: string;
  fecha_fin: string;
  sucursal_id: number | null;
  detalles: ICampanaDetalleData[];
  created_at?: string;
  updated_at?: string;
}
